import {CommandBase} from "./CommandBase";
import {Asset} from "../entities/Asset";
import {CommandManager} from "../libs/CommandManager";

export class CommandActivateDirective extends CommandBase implements ng.IDirective {
    restrict= 'AEC';
    transclude = false;
    template = require('../../views/cmdactivate.html').default;
    scope = {
        selectedItems : "=",
        commandEnabled : "="
    };
    constructor(commandManager:CommandManager) {
        super(commandManager);
    }
    controller = ['$scope',($scope:any)=>{
        var zootzooter= 3;
        $scope.vm = this;
        $scope.$watch(()=>$scope.selectedItems.length, (newVal:any)=> {
            this.selectedItems = $scope.selectedItems;
        });
    }]
    getCommandText(asset:Asset):string{
        return asset.vTagID;
    }
    getCommandType():string{
        return "Activate";
    }
    static factory():ng.IDirectiveFactory {
        var directive = (commandManager:CommandManager) => {
            return new CommandActivateDirective(commandManager);
        }
        directive.$inject = ['CommandManager'];
        return directive;
    }
}
